import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
    root: {
        padding: 10,
        background: '#141b33',
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        width: 'calc(100% - 20px)',
        borderRadius: '4px',
    }
}))

const FieldInput = ({
    name,
    type = "text",
    placeholder,
    register,
    disabled
}) => {
    const classes = useStyles();

    return (
        <label htmlFor={name}>
            <input
                className={classes.root}
                {...register(name)}
                type={type}
                id={name}
                disabled={disabled}
                placeholder={placeholder}
            />
        </label>
    )
}

export default FieldInput;